export default {
  path: 'finance',
  name: 'finance',
  component: () => import('@/views/recharge-log/index.vue'),
  meta: {
    locale: '财务管理',
    requiresAuth: true,
    icon: 'icon-swap',
  },
  children: [
    {
      path: 'recharge-log-list',
      name: 'recharge-log-list',
      component: () => import('@/views/recharge-log/list/index.vue'),
      meta: {
        locale: '充值列表',
        requiresAuth: true,
        roles: ['super', 'admin', 'treasurer'],
      },
    },
    {
      path: 'cacheout-list',
      name: 'cacheout-list',
      component: () => import('@/views/cacheout/list/index.vue'),
      meta: {
        locale: '提现列表',
        requiresAuth: true,
        roles: ['super', 'admin', 'treasurer'],
      },
    },
    {
      path: 'cacheout-channel',
      name: 'cacheout-channel',
      component: () => import('@/views/cacheout/channel/index.vue'),
      meta: {
        locale: '提现方式管理',
        requiresAuth: true,
        roles: ['super', 'admin', 'treasurer'],
      },
    },
    {
      path: 'user-debt-list',
      name: 'user-debt-list',
      component: () => import('@/views/user-debt/list/index.vue'),
      meta: {
        locale: '欠款/充值备注',
        requiresAuth: true,
        roles: ['super', 'admin', 'service', 'special_service', 'treasurer'],
      },
    },
    {
      path: 'contract-signing',
      name: 'contract-signing-list',
      component: () => import('@/views/contract-signing/list/index.vue'),
      meta: {
        locale: '合同签约管理',
        requiresAuth: true,
        roles: ['super', 'admin', 'treasurer'],
      },
    },
    {
      path: 'kyc',
      name: 'kyc-list',
      component: () => import('@/views/kyc/list/index.vue'),
      meta: {
        locale: 'KYC身份验证',
        requiresAuth: true,
        roles: ['super', 'admin', 'treasurer'],
      },
    },
  ],
};
